import { apiBaseUrl } from '../apiConsts';

import { sendWithoutBody } from '../fetchUtils';
import type { FetchResult } from '../fetchUtils';

const refundApiKey = 'Icp73mNDj6qsu9mjCrx85CGZwyOIaLULt/IIaZCz/3yA+5tw9Wv1/w==';

export const updateMemberSubscription = (
  subscriptionId: string,
  status: string,
): Promise<FetchResult<null>> => {
  return sendWithoutBody(`${apiBaseUrl}payment/subscription`, {
    headers: { 'content-type': 'application/json' },
    method: 'PATCH',
    body: JSON.stringify({
      subscriptionId,
      status,
    }),
  });
};

export const refundSubscription = (
  subscriptionId: string,
): Promise<FetchResult<null>> => {
  return sendWithoutBody(`${apiBaseUrl}payment/transaction/refund`, {
    headers: { 'content-type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({
      subscriptionId,
      apiKey: refundApiKey,
    }),
  });
};
